jQuery(function ($) {
	console.log('slick');
	$('.key-images').slick({
		// dots: true,
		lazyLoad: 'progressive',
		autoplay: true,
		autoplaySpeed: 4500,
		fade: true,
		infinite: true,
		speed: 500,
		cssEase: 'linear',
		arrows: false,
	});
});
